import { useMutation } from "@tanstack/react-query";
import { call } from "../../../services/http-client";
import { Button, Header, Segment } from "semantic-ui-react";
import { useTranslation } from "react-i18next";
import { useEffect } from "react";

const Troubleshooting = ({}) => {
    const { t } = useTranslation();

    const sendTroubleshootingInfoMutation = useMutation({
        mutationFn: async (troubleshootingInfo) => {
            await call('POST','','troubleshoot',{kind:'TROUBLESHOUTING', troubleshootingInfo});
        }
    }
    );
    
    useEffect(() => {
        const displayTroubleshootingInfoListener = async (event) => {
           await sendTroubleshootingInfoMutation.mutateAsync(event)
        }
        window.addEventListener('ulty:troubleshooting', displayTroubleshootingInfoListener, false);
        return () => {
            window.removeEventListener('ulty:troubleshooting', displayTroubleshootingInfoListener, false);
        }
    })

    return (
            <Segment basic>
                        <Header>{t('administration.device.troubleshooting', 'Diagnostics')}</Header>
                        <Button disabled={!sendTroubleshootingInfoMutation.isIdle} color="teal" onClick={() => {
                            window.Android.sendTroubleshootingInfo()
                        }}>{t('administration.device.send_troubleshooting_info', 'Envoyer les données de diagnostics')}</Button>
                    </Segment>
    )
}

export {Troubleshooting}